import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  height: 0;
  border: 1px solid ${(props) => props.theme.miles.colors.dark.alpha['700']};
`;
